import React, { Component } from 'react'
import Link from 'react-router-dom/Link'
import Title from '../../../../components/typography/title.component'
import Button from '../../../../components/buttons/buttons.component'
import InnerPageContainer from '../../../../components/layout/private/inner-page-container.component'
import { routes } from '../../../../constants/routes.constants'
import { connect } from 'react-redux'
import { history } from './../../../../helpers/history'
import { withRouter } from 'react-router-dom'
import { UserService } from '../../../../services/user.service'

class ClubSuccess extends Component {
	render() {
		const { orderNumber, name, email } = this.props.location.state

		return (
			<InnerPageContainer>
				<Title>
					Olá {UserService.getFirstName(name)}! Seja bem-vindo(a) ao Clube
					Muviflex
				</Title>
				<h3 className="center semi-bold">
					Pedido de compra <span className="blue">{orderNumber}</span>
				</h3>
				<h3 className="center semi-bold orange">
					Seu pagamento foi recebido! <br /> Um e-mail de confirmação da
					compra foi enviado para {email}
				</h3>
				<p className="center">
					Confira suas compras clicando{' '}
					<Link to={`${routes.CLIENTE}/minhas-compras`}>aqui</Link>
				</p>
				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
						margin: '4rem auto'
					}}>
					<Button
						primary
						style={{ marginBottom: '4rem' }}
						onClick={() => history.push('/')}>
						Troque seus pontos por passagens
					</Button>
				</div>
			</InnerPageContainer>
		)
	}
}

const connectedClubSuccess = withRouter(
	connect(
		null,
		null
	)(ClubSuccess)
)

export { connectedClubSuccess as ModuleRootComponent }
